import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=46a88b29&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a88b29')) {
      api.createRecord('46a88b29', component.options)
    } else {
      api.reload('46a88b29', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=46a88b29&", function () {
      api.rerender('46a88b29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NotFound.vue"
export default component.exports